"use strict";

const core = require('./core');
const mix = require('./mix');
const TimeRange = require('../time-range');

/**
 * Mixin methods which allow to add TimeRange component into ConfigurePane
 *
 * @param superclass
 * @returns {{}}
 * @constructor
 */
function TimeRangeMixin(superclass) {
	return class extends superclass {
		initTimeRange(options) {
			options = Object.assign({}, options);
			this.addComponent('timeRange', new TimeRange(options));
		}
	};
}

mix.MIXINS.set('TIME_RANGE', TimeRangeMixin);
exports.mixin = TimeRangeMixin;
